import { Injectable } from '@angular/core';
import { WindowRef } from '../window.service';
import { AnalyticEvent, CustomDimensionEvent } from './index';

@Injectable()
export class AnalyticsService {
  private dataLayer: any;

  constructor(private window: WindowRef) {
    this.dataLayer = window.nativeWindow['dataLayer'];
  }

  sendEvent(event: AnalyticEvent) {
    if (this.dataLayer) {
      this.dataLayer.push({
        event: event.getType(),
        eventCategory: event.getCategory(),
        eventAction: event.getAction(),
        eventLabel: event.getLabel()
      });
    }
  }

  public sendCustomDimensions(event: CustomDimensionEvent) {
    const customDimensions = {
      Site: event.getSite(),
      Product: event.getProduct(),
      Page_Flow: event.getPageFlow(),
      Reviews_Source: event.getReviewsSource(),
      Reviews_Number: event.getReviewsNumber(),
      Reviews_Total_Number: event.getReviewsTotalNumber()
    };

    if (this.dataLayer) {
      this.dataLayer.push(customDimensions);
    }
  }
}
